export const GOOGLE_MAPS_API_KEY = "AIzaSyCaYk1l7L9STHEzAgamAeVcUsbrWTtdd9M";
export const GOOGLE_MAPS_VERSION = "weekly";
